/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Day_SunInputs */

const en_ui_day_sun = /** @type {(inputs: Ui_Day_SunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sun`)
};

const de_ui_day_sun = /** @type {(inputs: Ui_Day_SunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So`)
};

/**
* | output |
* | --- |
* | "Sun" |
*
* @param {Ui_Day_SunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_day_sun = /** @type {((inputs?: Ui_Day_SunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Day_SunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_day_sun(inputs)
	return de_ui_day_sun(inputs)
});